import React, { useMemo } from 'react';
import { importConsultantsPhotos } from 'lib/utils/imagesUtils';
import styles from './ConsultantPhotoAndName.module.scss';

const ConsultantPhotoAndName = ({ name, position, phone, isPrimary, additionalType }) => {
  const consultantsPhotos = useMemo(() => importConsultantsPhotos(), []);
  const primaryClassName = isPrimary ? styles.primary : styles.secondary;
  const additionalTypeClassName = additionalType ? styles[additionalType] : '';
  const classes = `${styles.ConsultantPhotoAndName} ${primaryClassName} ${additionalTypeClassName}`;
  const photo = name ?
    consultantsPhotos[
      name.replace(/\s/g, '-')
        .replace(/é/g, 'e')
        .replace(/ö/g, 'o')
    ] : '';

  return (
    <figure className={ classes }>
      <div className={ styles.frame }>
        <img src={ photo } />
      </div>
      <figcaption>
        { isPrimary ? <h5 className={ styles.name }>{ name }</h5> : <hr /> }
        { isPrimary ? <h6 className={ styles.position }>{ position }</h6> : <hr /> }
        { isPrimary ? <h6 className={ styles.phone }>{ phone }</h6> : <hr /> }
      </figcaption>
    </figure>
  );
};

const ConsultantOnLightBg = ({ ...props }) => {
  return (
    <ConsultantPhotoAndName
      { ...props }
      additionalType="lightBg"
    />
  );
};
 
export { ConsultantOnLightBg };

export default ConsultantPhotoAndName;
